import styled from 'styled-components';

export const Types = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  gap: 12px;
  padding: 12px;
  width: 100%;
  overflow-y: auto;
  scrollbar-width: none;
  position: absolute;
`;

export const TypeLabel = styled.div<{active?: boolean}>`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #FFF;
  white-space: nowrap;
  border-radius: 20px;
  font-size:12px;
  padding: 5px 10px;
  ${({ active }) => active && {
    background: '#1C1C1C',
    color: '#FFF',
  }}
`;

export const Place = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: row;
  background: #FFF;
  border-radius: 12px;
  padding: 12px;
  width: 100%;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  margin-top: auto;
`;

export const PlacetypeContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  gap: 12px;
  width: 100%;
`;

export const PlaceContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  flex: 1;
`;

export const PlaceIcon = styled.img`
  width: 32px;
  height: 32px;
`;

export const PlaceType = styled.span`
  font-size: 14px;
  line-height: 1.2; 
  font-weight: 500;
  color: #1C1C1C;
  flex: 1;
`;

export const PlaceName = styled.span`
  font-size: 14px;
  line-height: 1.2; 
  font-weight: 500;
  color: #1C1C1C;
  flex: 1;
`;

export const PlaceAddress = styled.span`
  font-size: 14px;
  line-height: 1.5; 
  font-weight: 400;
  color: #52525B;
  margin-top:8px
  flex: 1;
`;

export const PlaceButton = styled.a`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #F4F4F5;
  border-radius: 50%;
`;
